import { GlamFlopsHero } from '@/components/brand/GlamFlopsHero';

export function HomePage() {
  return (
    <div className="bg-[var(--color-glam-black)]">
      <GlamFlopsHero />
    </div>
  );
}
